import {Container} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";
import makeStyles from "@material-ui/core/styles/makeStyles";
import PaperCopyOrderLine from "./PaperCopyOrderLine";

const useStyles = makeStyles(theme => ({
    gridItem: {
        display: 'flex'
    }
}));

export default ({
                    items,
                    handleDelete,
                    handleLongPress,
                    handleToggleSelected,
                    selectedItems,
                    selectMode,
                    scrollToItemUuid
                }) => {
    const theme = useTheme();
    const disableGutters = useMediaQuery(theme.breakpoints.down('xs'));
    const classes = useStyles();

    return <Box flexGrow={disableGutters ? 1 : 0} flexShrink={1}>
        <Container disableGutters={disableGutters}>
            <Grid container spacing={disableGutters ? 0 : 2} >
                {items.map((ol, i) => {
                    return <Grid item md={4} sm={6} xs={12} key={ol.uuid} classes={{item: classes.gridItem}}>
                        <PaperCopyOrderLine  key={ol.uuid} orderLine={ol}
                                             onDelete={handleDelete} onLongPress={handleLongPress}
                                             onToggleSelected={handleToggleSelected}
                                             scrollToItemUuid={scrollToItemUuid}
                                             selectMode={selectMode} selectedItems={selectedItems}
                        />
                    </Grid>
                })}
            </Grid>
        </Container>
    </Box>
}